


export class ZVSD3 {
  "purchasingDocumentCategory";
  "purchasingDocument";
  "vendorsNumber";
  "purchasingOrganization";
  "purchasingGroup";
  "purchasingDocumentType";
  "currencyKey";
  "exchangeRate";
  "deletionIndicatorInPurchasingDocument";
  "statusOfPurchasingDocument";
  "dateOnWhichTheRecordWasCreated";
  "nameOfPersonWhoCreatedTheObject";
  "languageKey";
  "termsOfPaymentKey";
  "purchasingDocumentDate";
  "incotermsPart1";
  "incotermsPart2";
  "numberOfTheDocumentCondition";
  "procedurePricingOutputControlAcctDetCosting";
  "releaseIndicatorPurchasingDocument";
  "collectiveNumber";
  "itemNumberOfPurchasingDocument";
  "deletionIndicatorInPurchasingDocument2";
  "rfqStatus";
  "purchasingDocumentItemChangeDate";
  "shortText";
  "materialNumber";
  "companyCode";
  "plant";
  "storageLocation";
  "purchaseOrderQuantity";
  "orderUnit";
  "netPriceInPurchasingDocumentInDocumentCurrency";
  "priceUnit";
  "netOrderValueInPoCurrency";
  "grossOrderValueInPoCurrency";
  "taxOnSalesPurchasesCode";
  "stockType";
  "deliveryCompletedIndicator";
  "finalInvoiceIndicator";
  "itemCategoryInPurchasingDocument";
  "accountAssignmentCategory";
  "consumptionPosting";
  "specialStockIndicator";
  "grossWeight";
  "volume";
  "volumeUnit";
  "incotermsPart12";
  "incotermsPart22";
  "purchaseRequisitionNumber";
  "itemNumberOfPurchaseRequisition";
  "valuationType";
  "sequenceOfTheConditionWithinAProcedure";
  "conditionType";
  "rateUnity";
  "conditionBaseValue";
  "currency";
  "conditionValue";
  "itemNumberOfPurchasingDocument2";
  "deliveryScheduleLineCounter";
  "itemDeliveryDate";
  "scheduledQuantity";
  "previousQuantityDeliveryScheduleLines";
  "quantityOfGoodsReceived";
  "issuedQuantity";
  "deliveryDateTimeSpot";
  "purchasingRequisitionNumber";
  "itemNumberOfPurchaseRequisition2";
  "creationIndicatorPurchaseRequisitionScheduleLines";
  "itemNumberOfPurchasingDocument3";
  "serialNumberForPReqAccountAssignmentSegment";
  "deletionIndicatorInPurchasingDocument3";
  "purchaseRequisitionQuantity";
  "distributionPercentageInTheCaseOfMultipleAcctAssgt";
  "gLAccountNumber";
  "businessArea";
  "costCenter";
  "projectNumber";
  "salesAndDistributionDocumentNumber";
  "salesDocumentItem";
  "scheduleLine";
  "orderNumber";
  "controllingArea";
  "profitCenter";
  "workBreakdownStructureElementWbsElement";
  "networkNumberForAccountAssignment";
  "itemNumberOfPurchasingDocument4";
  "serialNumberForPReqAccountAssignmentSegment2";
  "transactionEventTypePurchaseOrderHistory";
  "materialDocYear";
  "numberOfMaterialDocument";
  "itemInMaterialDocument";
  "poHistoryCategory";
  "movementTypeInventoryManagement";
  "postingDateInTheDocument";
  "quantity";
  "quantityInPurchaseOrderPriceUnit";
  "amountInLocalCurrency";
  "amountInDocumentCurrency";
  "currencyKey2";
  "grIrAccountClearingValueInLocalCurrency";
  "debitCreditIndicator";
  "valuationType2";
  "deliveryCompletedIndicator2";
  "referenceDocumentNumber";
  "fiscalYearOfAReferenceDocument";
  "documentNumberOfAReferenceDocument";
  "taxOnSalesPurchaseCode";
  "documentDateInDocument";
  "nameOfPersonWhoCreatedTheObject2";
  "reversalDocumentNumber";
  "fiscalYearOfReversalDocument";
  "notaFiscalType";
  "referenceType";
  "referenceToSourceDocument";
  "documentNumber";
  "documentItemNumber";
  "notaFiscalNumber";
  "series";
  "formOfNotaFiscal";
  "accountingDocumentNumber";
  "fiscalYear";
  "cancelled";
  "cancelDate";
  "nFCreationDate";
  "dtImportacao";
  "transacaoOrigem";
  "id";
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ZVSD3`.
   */
  static getModelName() {
    return "ZVSD3";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ZVSD3 for dynamic purposes.
  **/
  static factory(data) {
    return new ZVSD3(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'ZVSD3',
      plural: 'ZVSD3s',
      path: 'ZVSD3s',
      properties: {
        "purchasingDocumentCategory": {
          name: 'purchasingDocumentCategory',
          type: 'string'
        },
        "purchasingDocument": {
          name: 'purchasingDocument',
          type: 'string'
        },
        "vendorsNumber": {
          name: 'vendorsNumber',
          type: 'string'
        },
        "purchasingOrganization": {
          name: 'purchasingOrganization',
          type: 'string'
        },
        "purchasingGroup": {
          name: 'purchasingGroup',
          type: 'string'
        },
        "purchasingDocumentType": {
          name: 'purchasingDocumentType',
          type: 'string'
        },
        "currencyKey": {
          name: 'currencyKey',
          type: 'string'
        },
        "exchangeRate": {
          name: 'exchangeRate',
          type: 'string'
        },
        "deletionIndicatorInPurchasingDocument": {
          name: 'deletionIndicatorInPurchasingDocument',
          type: 'string'
        },
        "statusOfPurchasingDocument": {
          name: 'statusOfPurchasingDocument',
          type: 'string'
        },
        "dateOnWhichTheRecordWasCreated": {
          name: 'dateOnWhichTheRecordWasCreated',
          type: 'string'
        },
        "nameOfPersonWhoCreatedTheObject": {
          name: 'nameOfPersonWhoCreatedTheObject',
          type: 'string'
        },
        "languageKey": {
          name: 'languageKey',
          type: 'string'
        },
        "termsOfPaymentKey": {
          name: 'termsOfPaymentKey',
          type: 'string'
        },
        "purchasingDocumentDate": {
          name: 'purchasingDocumentDate',
          type: 'string'
        },
        "incotermsPart1": {
          name: 'incotermsPart1',
          type: 'string'
        },
        "incotermsPart2": {
          name: 'incotermsPart2',
          type: 'string'
        },
        "numberOfTheDocumentCondition": {
          name: 'numberOfTheDocumentCondition',
          type: 'string'
        },
        "procedurePricingOutputControlAcctDetCosting": {
          name: 'procedurePricingOutputControlAcctDetCosting',
          type: 'string'
        },
        "releaseIndicatorPurchasingDocument": {
          name: 'releaseIndicatorPurchasingDocument',
          type: 'string'
        },
        "collectiveNumber": {
          name: 'collectiveNumber',
          type: 'string'
        },
        "itemNumberOfPurchasingDocument": {
          name: 'itemNumberOfPurchasingDocument',
          type: 'string'
        },
        "deletionIndicatorInPurchasingDocument2": {
          name: 'deletionIndicatorInPurchasingDocument2',
          type: 'string'
        },
        "rfqStatus": {
          name: 'rfqStatus',
          type: 'string'
        },
        "purchasingDocumentItemChangeDate": {
          name: 'purchasingDocumentItemChangeDate',
          type: 'string'
        },
        "shortText": {
          name: 'shortText',
          type: 'string'
        },
        "materialNumber": {
          name: 'materialNumber',
          type: 'string'
        },
        "companyCode": {
          name: 'companyCode',
          type: 'string'
        },
        "plant": {
          name: 'plant',
          type: 'string'
        },
        "storageLocation": {
          name: 'storageLocation',
          type: 'string'
        },
        "purchaseOrderQuantity": {
          name: 'purchaseOrderQuantity',
          type: 'string'
        },
        "orderUnit": {
          name: 'orderUnit',
          type: 'string'
        },
        "netPriceInPurchasingDocumentInDocumentCurrency": {
          name: 'netPriceInPurchasingDocumentInDocumentCurrency',
          type: 'string'
        },
        "priceUnit": {
          name: 'priceUnit',
          type: 'string'
        },
        "netOrderValueInPoCurrency": {
          name: 'netOrderValueInPoCurrency',
          type: 'string'
        },
        "grossOrderValueInPoCurrency": {
          name: 'grossOrderValueInPoCurrency',
          type: 'string'
        },
        "taxOnSalesPurchasesCode": {
          name: 'taxOnSalesPurchasesCode',
          type: 'string'
        },
        "stockType": {
          name: 'stockType',
          type: 'string'
        },
        "deliveryCompletedIndicator": {
          name: 'deliveryCompletedIndicator',
          type: 'string'
        },
        "finalInvoiceIndicator": {
          name: 'finalInvoiceIndicator',
          type: 'string'
        },
        "itemCategoryInPurchasingDocument": {
          name: 'itemCategoryInPurchasingDocument',
          type: 'string'
        },
        "accountAssignmentCategory": {
          name: 'accountAssignmentCategory',
          type: 'string'
        },
        "consumptionPosting": {
          name: 'consumptionPosting',
          type: 'string'
        },
        "specialStockIndicator": {
          name: 'specialStockIndicator',
          type: 'string'
        },
        "grossWeight": {
          name: 'grossWeight',
          type: 'string'
        },
        "volume": {
          name: 'volume',
          type: 'string'
        },
        "volumeUnit": {
          name: 'volumeUnit',
          type: 'string'
        },
        "incotermsPart12": {
          name: 'incotermsPart12',
          type: 'string'
        },
        "incotermsPart22": {
          name: 'incotermsPart22',
          type: 'string'
        },
        "purchaseRequisitionNumber": {
          name: 'purchaseRequisitionNumber',
          type: 'string'
        },
        "itemNumberOfPurchaseRequisition": {
          name: 'itemNumberOfPurchaseRequisition',
          type: 'string'
        },
        "valuationType": {
          name: 'valuationType',
          type: 'string'
        },
        "sequenceOfTheConditionWithinAProcedure": {
          name: 'sequenceOfTheConditionWithinAProcedure',
          type: 'string'
        },
        "conditionType": {
          name: 'conditionType',
          type: 'string'
        },
        "rateUnity": {
          name: 'rateUnity',
          type: 'string'
        },
        "conditionBaseValue": {
          name: 'conditionBaseValue',
          type: 'string'
        },
        "currency": {
          name: 'currency',
          type: 'string'
        },
        "conditionValue": {
          name: 'conditionValue',
          type: 'string'
        },
        "itemNumberOfPurchasingDocument2": {
          name: 'itemNumberOfPurchasingDocument2',
          type: 'string'
        },
        "deliveryScheduleLineCounter": {
          name: 'deliveryScheduleLineCounter',
          type: 'string'
        },
        "itemDeliveryDate": {
          name: 'itemDeliveryDate',
          type: 'string'
        },
        "scheduledQuantity": {
          name: 'scheduledQuantity',
          type: 'string'
        },
        "previousQuantityDeliveryScheduleLines": {
          name: 'previousQuantityDeliveryScheduleLines',
          type: 'string'
        },
        "quantityOfGoodsReceived": {
          name: 'quantityOfGoodsReceived',
          type: 'string'
        },
        "issuedQuantity": {
          name: 'issuedQuantity',
          type: 'string'
        },
        "deliveryDateTimeSpot": {
          name: 'deliveryDateTimeSpot',
          type: 'string'
        },
        "purchasingRequisitionNumber": {
          name: 'purchasingRequisitionNumber',
          type: 'string'
        },
        "itemNumberOfPurchaseRequisition2": {
          name: 'itemNumberOfPurchaseRequisition2',
          type: 'string'
        },
        "creationIndicatorPurchaseRequisitionScheduleLines": {
          name: 'creationIndicatorPurchaseRequisitionScheduleLines',
          type: 'string'
        },
        "itemNumberOfPurchasingDocument3": {
          name: 'itemNumberOfPurchasingDocument3',
          type: 'string'
        },
        "serialNumberForPReqAccountAssignmentSegment": {
          name: 'serialNumberForPReqAccountAssignmentSegment',
          type: 'string'
        },
        "deletionIndicatorInPurchasingDocument3": {
          name: 'deletionIndicatorInPurchasingDocument3',
          type: 'string'
        },
        "purchaseRequisitionQuantity": {
          name: 'purchaseRequisitionQuantity',
          type: 'string'
        },
        "distributionPercentageInTheCaseOfMultipleAcctAssgt": {
          name: 'distributionPercentageInTheCaseOfMultipleAcctAssgt',
          type: 'string'
        },
        "gLAccountNumber": {
          name: 'gLAccountNumber',
          type: 'string'
        },
        "businessArea": {
          name: 'businessArea',
          type: 'string'
        },
        "costCenter": {
          name: 'costCenter',
          type: 'string'
        },
        "projectNumber": {
          name: 'projectNumber',
          type: 'string'
        },
        "salesAndDistributionDocumentNumber": {
          name: 'salesAndDistributionDocumentNumber',
          type: 'string'
        },
        "salesDocumentItem": {
          name: 'salesDocumentItem',
          type: 'string'
        },
        "scheduleLine": {
          name: 'scheduleLine',
          type: 'string'
        },
        "orderNumber": {
          name: 'orderNumber',
          type: 'string'
        },
        "controllingArea": {
          name: 'controllingArea',
          type: 'string'
        },
        "profitCenter": {
          name: 'profitCenter',
          type: 'string'
        },
        "workBreakdownStructureElementWbsElement": {
          name: 'workBreakdownStructureElementWbsElement',
          type: 'string'
        },
        "networkNumberForAccountAssignment": {
          name: 'networkNumberForAccountAssignment',
          type: 'string'
        },
        "itemNumberOfPurchasingDocument4": {
          name: 'itemNumberOfPurchasingDocument4',
          type: 'string'
        },
        "serialNumberForPReqAccountAssignmentSegment2": {
          name: 'serialNumberForPReqAccountAssignmentSegment2',
          type: 'string'
        },
        "transactionEventTypePurchaseOrderHistory": {
          name: 'transactionEventTypePurchaseOrderHistory',
          type: 'string'
        },
        "materialDocYear": {
          name: 'materialDocYear',
          type: 'string'
        },
        "numberOfMaterialDocument": {
          name: 'numberOfMaterialDocument',
          type: 'string'
        },
        "itemInMaterialDocument": {
          name: 'itemInMaterialDocument',
          type: 'string'
        },
        "poHistoryCategory": {
          name: 'poHistoryCategory',
          type: 'string'
        },
        "movementTypeInventoryManagement": {
          name: 'movementTypeInventoryManagement',
          type: 'string'
        },
        "postingDateInTheDocument": {
          name: 'postingDateInTheDocument',
          type: 'string'
        },
        "quantity": {
          name: 'quantity',
          type: 'string'
        },
        "quantityInPurchaseOrderPriceUnit": {
          name: 'quantityInPurchaseOrderPriceUnit',
          type: 'string'
        },
        "amountInLocalCurrency": {
          name: 'amountInLocalCurrency',
          type: 'string'
        },
        "amountInDocumentCurrency": {
          name: 'amountInDocumentCurrency',
          type: 'string'
        },
        "currencyKey2": {
          name: 'currencyKey2',
          type: 'string'
        },
        "grIrAccountClearingValueInLocalCurrency": {
          name: 'grIrAccountClearingValueInLocalCurrency',
          type: 'string'
        },
        "debitCreditIndicator": {
          name: 'debitCreditIndicator',
          type: 'string'
        },
        "valuationType2": {
          name: 'valuationType2',
          type: 'string'
        },
        "deliveryCompletedIndicator2": {
          name: 'deliveryCompletedIndicator2',
          type: 'string'
        },
        "referenceDocumentNumber": {
          name: 'referenceDocumentNumber',
          type: 'string'
        },
        "fiscalYearOfAReferenceDocument": {
          name: 'fiscalYearOfAReferenceDocument',
          type: 'string'
        },
        "documentNumberOfAReferenceDocument": {
          name: 'documentNumberOfAReferenceDocument',
          type: 'string'
        },
        "taxOnSalesPurchaseCode": {
          name: 'taxOnSalesPurchaseCode',
          type: 'string'
        },
        "documentDateInDocument": {
          name: 'documentDateInDocument',
          type: 'string'
        },
        "nameOfPersonWhoCreatedTheObject2": {
          name: 'nameOfPersonWhoCreatedTheObject2',
          type: 'string'
        },
        "reversalDocumentNumber": {
          name: 'reversalDocumentNumber',
          type: 'string'
        },
        "fiscalYearOfReversalDocument": {
          name: 'fiscalYearOfReversalDocument',
          type: 'string'
        },
        "notaFiscalType": {
          name: 'notaFiscalType',
          type: 'string'
        },
        "referenceType": {
          name: 'referenceType',
          type: 'string'
        },
        "referenceToSourceDocument": {
          name: 'referenceToSourceDocument',
          type: 'string'
        },
        "documentNumber": {
          name: 'documentNumber',
          type: 'string'
        },
        "documentItemNumber": {
          name: 'documentItemNumber',
          type: 'string'
        },
        "notaFiscalNumber": {
          name: 'notaFiscalNumber',
          type: 'string'
        },
        "series": {
          name: 'series',
          type: 'string'
        },
        "formOfNotaFiscal": {
          name: 'formOfNotaFiscal',
          type: 'string'
        },
        "accountingDocumentNumber": {
          name: 'accountingDocumentNumber',
          type: 'string'
        },
        "fiscalYear": {
          name: 'fiscalYear',
          type: 'string'
        },
        "cancelled": {
          name: 'cancelled',
          type: 'string'
        },
        "cancelDate": {
          name: 'cancelDate',
          type: 'string'
        },
        "nFCreationDate": {
          name: 'nFCreationDate',
          type: 'string'
        },
        "dtImportacao": {
          name: 'dtImportacao',
          type: 'Date'
        },
        "transacaoOrigem": {
          name: 'transacaoOrigem',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ZVSD3.js